import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/user-profile/ProfileView.tsx");
